/**
 * Created by linjianxi on 2016/10/29.
 */
import * as actions from './actions'
import * as getters from './getter'
import * as types from './mutation-type'

const state = {
  isShow: false,
  hasfundaccount: false,  // 未绑定银行卡
  hasverified: false,     // 未实名
  gridData: {},
  live: {}
}
const mutations = {
  [types.GET_HQPORD_INDEX_LIST] (state, reuslt) {
    state.gridData = reuslt
  },
  [types.CHECK_OPEN_MONEY_STATUS] (state, stu) {
    state.isShow = stu.isShow
  },
  [types.GET_HQPORD_LIVE_COUNT] (state, result) {
    state.hasfundaccount = result.hasfundaccount
    state.hasverified = result.hasverified
    state.live = result
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_index/store.js